// Events
import { THEME_CART_UPDATED } from 'events';
import { component } from 'picoapp';

export default component(async (node, ctx) => {
  const render = (cart) => {
    if (cart.item_count > 0) {
      node.hidden = false;
      node.textContent = cart.item_count.toString();
    } else {
      node.hidden = true;
      node.textContent = '';
    }
  };

  ctx.on(THEME_CART_UPDATED, ({ cart }) => render(cart));
});
